var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"has-text-weight-bold is-size-4 mb-1"},[_vm._v(" "+_vm._s(_vm.$t("mp:application.data_validation.title"))+" ")]),_c('application-template',{attrs:{"template":"MERCHANT_APPLICATION_DATA_VALIDATION"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }